import orgList from './reducers/orgList';
export default {
    orgList: {
        reducer: orgList,
    },
};
